import type { GiftPassSendRow } from '../../api/gift-passes';

import { GiftPassCardHeading } from './GiftPassCardHeading';
import { GiftPassSendItem } from './GiftPassSendItem';

function sendCountLabel(count: number): string {
  return `${count} ${count === 1 ? 'send' : 'sends'} · newest first`;
}

export function GiftPassSendHistoryCard({ sends }: { sends: GiftPassSendRow[] }) {
  return (
    <section className="nb-card nb-card-tight" style={{ padding: 0, overflow: 'hidden' }}>
      <GiftPassCardHeading title="Send history" detail={sendCountLabel(sends.length)} />
      {sends.length === 0 ? (
        <div style={{ padding: '18px 16px', fontSize: 12.5, color: 'var(--nb-subtle)' }}>
          This pass has not been sent to anyone.
        </div>
      ) : (
        <ul style={{ listStyle: 'none', margin: '0 0 -1px', padding: 0 }}>
          {sends.map((send) => (
            <GiftPassSendItem key={send.id} send={send} />
          ))}
        </ul>
      )}
    </section>
  );
}
